import {AppConfigService} from '@services/app-config.service';
import {LoginService} from '@services/login.service';
import {I18nService} from '@services/i18n.service';
import {PermissionService} from '@services/permission.service';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

export const appConfigFactory = (
  loginService: LoginService,
  appConfigService: AppConfigService,
  i18nService: I18nService,
  permissionService: PermissionService,
  http: HttpClient
) => {
  const setExternalConfig = async () => {
    try {
      const configData = await http.get<any>('assets/infra.json').toPromise();
      environment.production = configData.production;
      environment.apiUrl = configData.apiUrl;
      environment.google = {
        oAuthClientId: configData.google?.oAuthClientId,
        mapsApiKey: configData.google?.mapsApiKey
      };
      environment.firebase = {
        apiKey: configData.firebase?.apiKey,
        authDomain: configData.firebase?.authDomain,
        projectId: configData.firebase?.projectId,
        storageBucket: configData.firebase?.storageBucket,
        messagingSenderId: configData.firebase?.messagingSenderId,
        appId: configData.firebase?.appId,
        vapidKey: configData.firebase?.vapidKey
      };
      environment.captcha = {
        type: configData.captcha?.type,
        scriptUrl: configData.captcha?.scriptUrl,
        siteKey: configData.captcha?.siteKey
      };
    } catch (error) {
      console.error(error);
      throw new Error('Could not load external configuration');
    }
  };
  return async (): Promise<any> => {
    await setExternalConfig();
    i18nService.initLang();

    if (!loginService.isLoggedIn(true)) {
      return;
    }

    await appConfigService.init();
    await permissionService.init();
  };
};
